var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.748 2.6a1 1 0 011.061.595l2.003 4.674A1 1 0 0111.6 8.97l-1.44 1.441a7.446 7.446 0 003.926 3.927l1.441-1.44a1 1 0 011.101-.213l4.674 2.003a1 1 0 01.596 1.061l-.63 4.409a1 1 0 01-.943.857 16.069 16.069 0 01-12.142-4.7 16.068 16.068 0 01-4.7-12.142 1 1 0 01.857-.944l4.408-.63zM5.466 5.088a14.059 14.059 0 004.13 9.811 14.059 14.059 0 009.813 4.132l.4-2.807-3.346-1.435-1.419 1.419a1 1 0 01-1.023.242 9.445 9.445 0 01-5.974-5.974 1 1 0 01.242-1.024l1.418-1.418-1.434-3.347-2.807.4z",
    fill: "#808089"
  })));
}

export default SvgPhoneIcon;